import { CSSProperties } from 'react';
import {
  getTruncateMaxLinesStyle,
  WbTooltip,
} from '@agilelab/plugin-wb-platform';
import { Box, Typography, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { SubComponentIcon } from './icons/SubComponentIcon';

type SubComponentProps = {
  className?: string;
  style?: CSSProperties;
  label: string;
};

const useStyles = makeStyles(
  theme => ({
    root: {
      padding: theme.spacing(1),
      width: '100%',
      backgroundColor: theme.palette.grey[100],
      border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.spacing(0.5),
      display: 'flex',
      color: theme.palette.secondary.main,
      gap: theme.spacing(1),
      alignItems: 'center',
      '&:last-child': {
        marginBottom: theme.spacing(1),
      },
    },
    label: {
      ...getTruncateMaxLinesStyle(1, false),
      fontWeight: 500,
    },
  }),
  { name: 'SubComponent' },
);

export const SubComponent = ({
  className,
  style,
  label,
}: SubComponentProps) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, className)} style={style}>
      <SubComponentIcon />
      <WbTooltip title={label}>
        <Typography className={classes.label}>{label}</Typography>
      </WbTooltip>
    </Box>
  );
};
